const de = {
    demo: {
        title: `Englisch`,
        introduction: `Lorem Ipsum`,
    },
    docs: {
        hi: `Hallo`,
        description: `Brauchen Sie Hilfe? \n Bitte schauen Sie in unsere Dokumentation.`,
        documentation: `Dokumentation`,
    },
    yes: `Ja`,
    no: `Nein`,
    home: `Startseite`,
    dashboard: `Dashboard`,
    user: `Benutzer`,
    account: `Konto`,
    general: `Allgemein`,
    settings: `Einstellungen`,
    username: `Benutzername`,
    login: `Anmelden`,
    logout: `Abmelden`,
    emailAddress: `E-Mail-Adresse`,
    password: `Passwort`,
    newPassword: `Neues Passwort`,
    oldPassword: `Altes Passwort`,
    confirmNewPassword: `Neues Passwort bestätigen`,
    updatePassword: `Passwort aktualisieren`,
    formErrorValidEmail: `E-Mail muss eine gültige E-Mail-Adresse sein`,
    formErrorEmailRequired: `E-Mail ist erforderlich`,
    formErrorPasswordRequired: `Passwort ist erforderlich`,
    formErrorOldPasswordRequired: `Altes Passwort ist erforderlich`,
    formErrorPasswordLength: `Passwort muss mindestens 6 Zeichen lang sein`,
    formErrorConfirmPasswordRequired: `Passwortbestätigung ist erforderlich`,
    formErrorPasswordsMatch: `Passwörter müssen übereinstimmen`,
    formForgotPasswordLink: `Passwort vergessen?`,
    snackBarChangePasswordSuccess: `Passwortänderung erfolgreich!`,
    snackBarUpdateSuccess: `Aktualisierung erfolgreich!`,
    active: `Aktiv`,
    inactive: `Inaktiv`,
    on: `Ein`,
    off: `Aus`,
    billing: `Abrechnung`,
    description: `Beschreibung`,
    amount: `Betrag`,
    status: `Status`,
    changePassword: `Passwort ändern`,
    changeSettings: `Einstellungen ändern`,
    setup: `Einrichten`,
    free: `Kostenlos`,
    invoices: `Rechnungen`,
    cancelSubscriptionButton: `Abonnement kündigen`,
    date: 'Datum',
    download: 'Herunterladen',
    print: 'Drucken',
    close: 'Schließen',
    view: 'Ansehen',
    DataOwl: `Data Owl`,
    DataOwlTip: `Data Owl scannt verborgene Webquellen, um zu erkennen, ob deine E-Mail-Adresse in Datenlecks auftaucht, und hilft dir mit rechtzeitigen Warnungen sicher zu bleiben.`,
    warningBanner: {
        text: 'Sie haben kein aktives Konto. Um Ihr Konto zu aktivieren, erneuern Sie es, indem Sie auf die Schaltfläche klicken.',
        ctaButton: 'Erneuern',
        caption: 'Untertitel'
    },
    loginPage: {
        title: `Anmelden`,
        formTitle: `Neu bei Anomica? Konto erstellen`,
        formTitleLink: `hier`,
        formForgotPasswordLink: `Passwort vergessen?`
    },
    resetPasswordPage: {
        title: `Passwort zurücksetzen`,
        formTitle: `Passwort vergessen?`,
        formSubTitle: ` Bitte geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts per E-Mail.`,
        formTitleLink: `Zurück zur Anmeldung`,
        formButton: `Anfrage senden`,
    },
    newPasswordPage: {
        title: `Passwort zurücksetzen`,
        formTitle: `Anfrage erfolgreich gesendet!`,
        formSubTitle: `Wir haben eine E-Mail mit einem Bestätigungslink gesendet.`,
        formSubTitle2: `Bitte besuchen Sie den Link, um Ihre E-Mail zu verifizieren.`,
        formTitleLink: `Zurück zur Anmeldung`,
        formButton: `Anfrage senden`,
    },
    accountPage: {
        title: `Konto`,
        accountStatus: `Kontostatus`,
        accountType: `Kontotyp`,
        renewAccount: `Konto erneuern`,
        endDate: `Enddatum`,
        subRemaining: `Verbleibendes Abonnement:`,
        autoRenew: `Automatische Verlängerung ist`,
        vpnCredentials: `VPN-Anmeldeinformationen:`,
        setupVpn: `VPN einrichten`,
        nextBillingDate: `Nächstes Abrechnungsdatum`,
        endOfFreeTerm: `Ende der kostenlosen Periode`,
        cancelSubscription: `Abonnement kündigen`,
        activationCode: `Aktivierungscode`,
        newsNotifications: `News und Benachrichtigungs-E-Mails`,
        darkWebMonitoring: `Dark Web Shield`,
        setupMonitoring: `Monitoring einrichten`,
        recurringSubscription: `Wiederkehrendes Abonnement`,
        getSubscription: 'Abonnement erhalten',
        nextBillingDateWarning: 'Das genaue Abbuchungsdatum kann variieren und hängt von der Zahlungsmethode ab.',
        tabs: {
            general: `Allgemein`,
            settings: `Einstellungen`,
            changePassword: `Passwort ändern`
        },
    },
    settingsPage: {
        title: `Einstellungen`,
        formTitle: `BENACHRICHTIGUNGEN & NEWSLETTERS`,
        recurringPayment: ` Wiederkehrende Zahlung`,
        yourSubscription: `Ihr Abonnement`,
        per: `Pro`,
        curSubs: `Aktuelles Abonnement läuft weiter bis`,
        warn: `Ihr Konto wird nicht mehr monatlich verlängert.`,
        submitButton: `Änderungen speichern`,
        settingsOption1: `News und Ankündigungen`
    },
    setupVpnPage: {
        title: `VPN einrichten`,
        header: `Anomica für {{os}} herunterladen`,
        coverH1: `Die App mit einem Knopfdruck herunterladen`,
        coverH2: `Sie müssen nur herunterladen, alles ist für Sie ausgefüllt`,
        coverH3: `Auch verfügbar für`,
        coverButtonText: 'Herunterladen für ',
        setupBadge: `ANOMICA EINRICHTEN`,
        preferManual: `Lieber manuell installieren? Schauen Sie sich die Schritte unten an.`,
        installManuallyLink: `Manuell installieren`,
        footerText: `Falls Sie noch Fragen haben, kontaktieren Sie uns unter`,
        tabH1: `Der Aktivierungscode ist bereits für Sie ausgefüllt und Sie müssen Anomica nur herunterladen.`,
        tabH2: `Lieber manuell installieren?`,
        step1: ` Herunterladen`,
        step1Caption: `Der Aktivierungscode ist bereits für Sie ausgefüllt und Sie müssen Anomica nur herunterladen. Lieber manuell installieren?`,
        step2: ` Kopieren`,
        step2Caption: `Kopieren Sie den Aktivierungscode und verwenden Sie ihn während der Software-Einrichtung.`,
        step3: ` Einfügen`,
        step3Caption: `Fügen Sie den kopierten Aktivierungscode in die Software ein, um die Installation von Anomica abzuschließen.`,
        manual: {
          disabledTooltip: `Nur für autorisierte Benutzer mit einem aktiven Abonnement verfügbar.`,
          authRequired: `Bitte melde dich an, um fortzufahren.`,
          step1: `Server wählen`,
          step1Caption: `Wähle ein Land und einen Server für die Verbindung aus.`,
          country: `Land`,
          server: `Server`,
          protocol: `Protokoll`,
          step2: `Konfigurationsdatei herunterladen`,
          step2Caption: `Lade die .ovpn-Konfigurationsdatei für den ausgewählten Server herunter.`,
          downloadButton: `.ovpn herunterladen`,
          step3: `Verbinden`,
          step3Caption: `Öffne den OpenVPN-Client, importiere die heruntergeladene Datei und stelle die Verbindung her. Verwende den VPN-Login und das VPN-Passwort unten.`,
        },
    },
    promoPage: {

        tabH1: `Herzlichen Glückwunsch und Willkommen!. Ihr Traffic-Limit wurde aktualisiert. Genießen Sie 5 GB monatliche Nutzung. `,
        tabH2: `Sie müssen nur herunterladen, alles ist für Sie ausgefüllt`,
    },
    cancelSubscription: {
        h1: `Wenn Sie Ihr Abonnement kündigen möchten, `,
        h1br:`können Sie das unten einfach tun.`,
        sub1: `Wir freuen uns, dass Sie Mitglied waren. Sie sind immer herzlich willkommen, zurückzukommen.`,
        sub1br: `Sie können Ihre Kündigung unten abschließen.`,
        cardTitle: `Abonnement kündigen`,
        cardText: `Sind Sie sicher, dass Sie auf Ihre Online-Privatsphäre verzichten möchten? Verwenden Sie dann die Schaltfläche unten, um die Kündigung Ihres Abonnements abzuschließen.`,
        cancelButton: `Kündigung abschließen`,
        backButton: `Zurück zur Website`,
        cardCaption: `Die Kündigung wird am Ende Ihrer aktuellen Abrechnungsperiode wirksam`,
        cardCaptionBr: `am`,
        h2: `Warum bei Anomica bleiben?`,
        p1: `100% Privatsphäre`,
        p1c: `Mit Anomica gehören alle Sorgen um Ihre Online-Privatsphäre der Vergangenheit an. Niemand kann Ihre Daten einsehen und Sie können sich frei online bewegen.`,
        p2: `100% Sicherheit`,
        p2c: `Da eine VPN-Verbindung verschlüsselt ist, können Hacker nicht mehr einbrechen. Das verhindert, dass sie mit Ihren Daten davonlaufen.`,
        p3: `100% Freiheit`,
        p3c: `Mit Anomica können Sie Geo-Blocks umgehen und so tun, als wären Sie in einem anderen Land, sodass Sie 100% Online-Freiheit genießen.`,
        p4: `100% Streaming`,
        p4c: `Mit Anomica erhalten Sie Zugang zu jedem (ausländischen) Streaming-Dienst. Zusätzlicher Vorteil: Unsere superschnellen Verbindungen sind perfekt zum Streamen!`,
        p5: `100% Download`,
        p5c: `Mit den superschnellen Servern und modernen Protokollen von Anomica können Sie mühelos überall auf der Welt herunterladen und streamen.`,
        exButton: `Online sicher bleiben`,
        h1Canceled: `Sie haben Ihr Abonnement erfolgreich gekündigt.`,
        h1CanceledFree: `Sie haben Ihr Abonnement erfolgreich gekündigt.`,
        sub1Canceled: `Vielen Dank, dass Sie Mitglied waren. Kommen Sie jederzeit zurück!`,
        sure: `Sind Sie sicher?`,
        happy: `Wir freuen uns jederzeit, Sie wiederzusehen.`
    },
    verifyEmailPage: {
        title: ``,
        checkYourEmail: `Bitte überprüfen Sie Ihre E-Mail!`,
        inProgress: `Verifizierung läuft...`,
        bottomText: `Alle Informationen zu Ihrem Abonnement und der App finden Sie in Ihrem Posteingang.`,
        success: `E-Mail verifiziert!`,
        alreadyVerified: 'E-Mail bereits verifiziert!',
        button: `Ihr Konto ansehen`,
        p1: `Sie haben Anomica gewählt`,
        p2: `Sie haben sich erfolgreich registriert`,
        p3: `Ihre E-Mail-Adresse wurde erfolgreich verifiziert`,
        p4: `Ihr Anomica-Abonnement wurde aktiviert.`,
    },
    billingPage: {

        paymentFor: `Zahlung für`,
        invoiceNumber: `Rechnungs-ID`,
    },
    monitoringPage: {
      title: `Data Owl`,
      setUpMonitoring: `Monitoring einrichten`,
      featureActivatedAlert: `Data Owl ist jetzt aktiviert`,
      featureNotActivatedAlert: `Data Owl ist derzeit nicht aktiviert`,
      notifyToggleLabel: `Benachrichtigung erhalten, wenn ein neues Datenleck erkannt wird`,
      consentDisclaimer: `Indem du diese Funktion aktivierst, stimmst du zu, dass wir deine E-Mail-Adresse an sichere Scan-Dienste weitergeben, um auf Datenlecks zu prüfen. Du erhältst eine E-Mail-Benachrichtigung, wenn neue Lecks entdeckt werden.`,
      breachesDetectedTitle: `Datenlecks erkannt`,
      breachesFoundWarning: `Oh nein! Wir haben <0>{{number}} {{breachWord}}</0> gefunden, darunter geleakte Passwörter. Lies <1>unseren Artikel</1>, um mehr darüber zu erfahren, wie du dich vor zukünftigen Lecks schützen kannst.`,
      breach_one: `Datenleck`,
      breach_other: `Datenlecks`,
      btnUpdating: `Wird aktualisiert...`,
      btnSaveAndScan: `Änderungen speichern und jetzt scannen`,
      btnSave: `Änderungen speichern`,
      btnAddedToQueue: `Zur Warteschlange hinzugefügt...`,
      btnDataRetrieved: `Daten abgerufen`,
      compromisedData: `Geleakte Daten:`,
      dataOwl: {
        faq: {
          what_does_it_do: {
            heading: `Was macht diese Funktion?`,
            detail: `Das Data-Owl-Tool scannt kontinuierlich das Dark Web und bekannte geleakte Datenbanken nach den E-Mail-Adressen, die du überwachen möchtest. Wenn deine Daten in einem Leck gefunden werden, erhältst du sofort eine Warnung mit Details zur Quelle und zum Datum des Datenlecks, welche Daten offengelegt wurden und andere relevante Informationen. Du erhältst außerdem klare Anleitungen zum Schutz deiner Konten.`,
          },
          how_does_it_work: {
            heading: `Wie hilft mir dieses Tool, mich zu schützen?`,
            detail: `Datenlecks und Sicherheitsverletzungen passieren täglich und stellen eine große Bedrohung für deine Online-Sicherheit dar. Sobald deine Daten geleakt sind, können sie sofort für alle Arten von Cyberangriffen verwendet werden – von Phishing und Online-Betrug bis hin zu Kontoübernahmen und Finanzbetrug. Data Owl von Anomica hilft dir, immer einen Schritt voraus zu sein, indem es dich sofort informiert, wenn ein Datenleck auftritt, umfangreiche Berichte bietet und professionelle Anleitung gibt, um jede Situation zu bewältigen.`,
          },
          does_it_solve_anything: {
            heading: `Ist diese Funktion kostenlos?`,
            detail: `Das Data-Owl-Tool ist in jedem Anomica-Abonnement ohne zusätzliche Kosten enthalten. Es bietet 24/7-Überwachung, unbegrenztes E-Mail-Tracking, detaillierte Leak-Berichte und maßgeschneiderte Anleitungen, die dir helfen, auf jeden Vorfall zu reagieren.`,
          },
        },
      },
      dataClasses: {
        "Email addresses": `E-Mail-Adressen`,
        Passwords: `Passwörter`,
        Usernames: `Benutzernamen`,
        "IP addresses": `IP-Adressen`,
        "Physical addresses": `Physische Adressen`,
        "Phone numbers": `Telefonnummern`,
        Names: `Namen`,
        "Job titles": `Berufsbezeichnungen`,
        "Dates of birth": `Geburtsdaten`,
        "Financial data": `Finanzdaten`,
        "Credit cards": `Kreditkarten`,
        "Bank account numbers": `Bankkontonummern`,
        "Social security numbers": `Sozialversicherungsnummern`,
        "Historical passwords": `Alte Passwörter`,
      },
    },
    invoiceDetailsPage: {
        title: `Rechnung`,
        email: 'E-Mail',
        customerNumber: 'Kundennummer',
        invoiceFrom: 'Rechnung von',
        invoiceTo: 'Rechnung an',
        invoiceDate: 'Rechnungsdatum',
        invoicePaymentMethod: 'Zahlungsmethode',
        invoiceDescription: 'Beschreibung',
        invoiceProductQty: 'Menge',
        invoiceProductPrice: 'Preis',
        invoiceTotal: 'Gesamt',
        invoiceSubtotal: 'Zwischensumme',
        invoiceVat: 'Steuern (MwSt.)',
        supportDescription: 'Haben Sie eine Frage?',
        status: {
            open: 'Offen',
            paid: 'bezahlt',
            canceled: 'storniert',
            pending: 'ausstehend',
            chargeback: 'Rückbuchung',
            expired: 'abgelaufen',
            failed: 'fehlgeschlagen',
            settled: 'abgerechnet',
            partially_refunded: 'teilweise erstattet',
            refunded: 'erstattet',
            authorized: 'autorisiert',
            internal_error: 'interner Fehler',
        }
    },
    maintenancePage: {

        h1: `Wir führen Wartungsarbeiten durch.`,
        h2: `Gleich wieder da!`,
    },
    page404: {
        h1: `Ups… die Seite, die Sie suchen, existiert offenbar nicht.`,
        p: `Während Ihrer Suche nach dem niederländischen VPN-Anbieter verirrt? Keine Sorge, wir bringen Sie hin!`,
        btn: `Bringen Sie mich zum besten VPN!`,
    }
};

export default de;
